module.exports = __webpack_public_path__ + "static/media/303.a479bce4.jpg";